import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { AddReferenceValueDialog } from './add-dialog/add-reference-value-dialog.component';
import { AssignedReferenceFiguresDialogComponent } from './assigned-reference-figures-dialog.component';

export * from './assigned-reference-figures-dialog.component';
export * from './add-dialog/add-reference-value-dialog.component';

@NgModule({
    declarations: [ AssignedReferenceFiguresDialogComponent, AddReferenceValueDialog ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        MatMomentDateModule,
        TranslateModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatTableModule,
        MatSelectModule,
        MatInputModule,
        MatIconModule,
        FormsModule,
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    ],
})
export class AssignedReferenceFiguresDialogModule {
}
